import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Loader from '../shared/loader';
import cryptoService from '../services/crypto.service';

export class Login extends React.Component<{ isLoggedIn: boolean; user; location }, any> {
  auth(network, e) {
    window.location.href = `/auth/${network}`;
  }

  render() {
    if (this.props.isLoggedIn) {
      let originalLocation = JSON.parse(sessionStorage.getItem('redirect') || '""') || '/dashboard';
      const { location: { state: { from = originalLocation } = {} } = {} } = this.props;
      return <Redirect to={from} />;
    }

    if (this.props.user !== null) {
      return <Loader />;
    }

    cryptoService.reset();
    window.postMessage && window.postMessage('logout', '*');

    return (
      <div className="row">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="col s12 center">
          <button onClick={this.auth.bind(this, 'google')} className="waves-effect waves-light google btn">
            <img src="/images/google.png" /> Connect with Google&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </button>
        </div>

        <br />
        <br />
        <br />

        <div className="col s12 center">
          <button onClick={this.auth.bind(this, 'facebook')} className="waves-effect waves-light facebook btn">
            <img src="/images/facebook.png" /> Connect with Facebook&nbsp;
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/login/component.tsx